import {
  __spreadProps,
  __spreadValues
} from "../chunk-N3ETBM74.js";
const englishContent = {
  createAccount: "Create a new account",
  firstTimeHere: "First time here?",
  logIn: "Log in",
  logOut: "Log out",
  menuOneTitle: "Personal details",
  menuTwoTitle: "My bookings",
  menuThreeTitle: "Consent & privacy",
  myProfile: "My profile",
  or: "or"
};
const contentByLocale = {
  en: englishContent,
  "en-gb": englishContent,
  "bg-bg": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "\u041E\u0431\u0449\u0438",
    menuTwoTitle: "\u041C\u043E\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u0438",
    menuThreeTitle: "\u0421\u044A\u0433\u043B\u0430\u0441\u0438\u0435 \u0438 \u043A\u043E\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u044F"
  }),
  "cs-cz": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "Obecn\xE9",
    menuTwoTitle: "Moje rezervace",
    menuThreeTitle: "Souhlas a komunikace"
  }),
  "da-dk": {
    createAccount: "Opret bruger",
    firstTimeHere: "F\xF8rste gang du er her?",
    logIn: "Log ind",
    logOut: "Log af",
    menuOneTitle: "Personlige oplysninger",
    menuTwoTitle: "Mine bookinger",
    menuThreeTitle: "Samtykke & fortrolighed",
    myProfile: "Min profil",
    or: "or"
  },
  "de-de": {
    createAccount: "Benutzerkonto registrieren",
    firstTimeHere: "Zum ersten Mal hier?",
    logIn: "Anmelden",
    logOut: "Ausloggen",
    menuOneTitle: "Pers\xF6nliche details",
    menuTwoTitle: "Meine Buchungen",
    menuThreeTitle: "Datenschutz und einverst\xE4ndnis",
    myProfile: "Mein Profil",
    or: "or"
  },
  "es-es": {
    createAccount: "Crear una nueva cuenta",
    firstTimeHere: "\xBFEs su primera vez aqu\xED?",
    logIn: "Iniciar sesi\xF3n",
    logOut: "Cerrar sesi\xF3n",
    menuOneTitle: "General",
    menuTwoTitle: "Mis reservas",
    menuThreeTitle: "Consentimiento y comunicaci\xF3n",
    myProfile: "Mi perfil",
    or: "or"
  },
  "et-ee": {
    createAccount: "Loo kasutaja",
    firstTimeHere: "Sul ei ole veel kasutajat?",
    logIn: "Logi sisse",
    logOut: "Logi v\xE4lja",
    menuOneTitle: "\xDCldine",
    menuTwoTitle: "Minu broneeringud",
    menuThreeTitle: "N\xF5usolek ja suhtlus",
    myProfile: "Minu profiil",
    or: "or"
  },
  "fi-fi": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "Yleist\xE4",
    menuTwoTitle: "Omat varaukseni",
    menuThreeTitle: "Suostumus ja viestint\xE4"
  }),
  "fr-be": {
    createAccount: "Cr\xE9er un nouveau compte",
    firstTimeHere: "Premi\xE8re visite ?",
    logIn: "Se connecter",
    logOut: "Se d\xE9connecter",
    menuOneTitle: "D\xE9tails personnels",
    menuTwoTitle: "Mes r\xE9servations",
    menuThreeTitle: "Consentement et confidentialit\xE9",
    myProfile: "Mon profil",
    or: "or"
  },
  "fr-fr": {
    createAccount: "Cr\xE9er un nouveau compte",
    firstTimeHere: "Premi\xE8re visite ?",
    logIn: "Se connecter",
    logOut: "Se d\xE9connecter",
    menuOneTitle: "D\xE9tails personnels",
    menuTwoTitle: "Mes r\xE9servations",
    menuThreeTitle: "Consentement et confidentialit\xE9",
    myProfile: "Mon profil",
    or: "or"
  },
  "fr-ma": {
    createAccount: "Cr\xE9er un nouveau compte",
    firstTimeHere: "Premi\xE8re visite ?",
    logIn: "Se connecter",
    logOut: "Se d\xE9connecter",
    menuOneTitle: "D\xE9tails personnels",
    menuTwoTitle: "Mes r\xE9servations",
    menuThreeTitle: "Consentement et confidentialit\xE9",
    myProfile: "Mon profil",
    or: "or"
  },
  "it-it": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "Generale",
    menuTwoTitle: "Le mie prenotazioni",
    menuThreeTitle: "Consenso e comunicazioni"
  }),
  "lt-lt": {
    createAccount: "Sukurkite nauj\u0105 paskyr\u0105.",
    firstTimeHere: "Pirm\u0105 kart\u0105 \u010Dia?",
    logIn: "Prisijungti",
    logOut: "Atsijungti",
    menuOneTitle: "Asmenin\u0117s detal\u0117s",
    menuTwoTitle: "Mano u\u017Esakymai",
    menuThreeTitle: "Sutikimas ir privatumas",
    myProfile: "Mano profilis",
    or: "or"
  },
  "lv-lv": {
    createAccount: "Re\u0123istr\u0113jies \u0161eit",
    firstTimeHere: "Jums v\u0113l nav konta?",
    logIn: "Ielogoties",
    logOut: "Izrakst\u012Bties",
    menuOneTitle: "Personisk\u0101 inform\u0101cija",
    menuTwoTitle: "Mani rezerv\u0113jumi",
    menuThreeTitle: "Piekri\u0161ana un priv\u0101tums",
    myProfile: "Mans profils",
    or: "or"
  },
  "nl-be": {
    createAccount: "Meld je hier aan",
    firstTimeHere: "Nog geen account?",
    logIn: "Inloggen",
    logOut: "Log uit",
    menuOneTitle: "Persoonlijke gegevens",
    menuTwoTitle: "Mijn boekingen",
    menuThreeTitle: "Toestemming & privacy",
    myProfile: "Mijn profiel",
    or: "or"
  },
  "nl-nl": {
    createAccount: "Meld je hier aan",
    firstTimeHere: "Nog geen account?",
    logIn: "Inloggen",
    logOut: "Log uit",
    menuOneTitle: "Persoonlijke gegevens",
    menuTwoTitle: "Mijn boekingen",
    menuThreeTitle: "Toestemming & privacy",
    myProfile: "Mijn profiel",
    or: "or"
  },
  "pl-pl": {
    createAccount: "Stw\xF3rz nowe konto",
    firstTimeHere: "Pierwszy raz na naszej stronie?",
    logIn: "Zaloguj si\u0119",
    logOut: "Wyloguj",
    menuOneTitle: "Dane osobowe",
    menuTwoTitle: "Moje rezerwacje",
    menuThreeTitle: "Zgoda i prywatno\u015B\u0107",
    myProfile: "M\xF3j profil",
    or: "or"
  },
  "ro-ro": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "General",
    menuTwoTitle: "Rezerv\u0103rile mele",
    menuThreeTitle: "Consim\u021B\u0103m\xE2nt & comunicare"
  }),
  "ru-ru": {
    createAccount: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    firstTimeHere: "\u0415\u0449\u0435 \u043D\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u044B?",
    logIn: "\u0412\u043E\u0439\u0442\u0438",
    logOut: "\u0412\u044B\u0439\u0442\u0438",
    menuOneTitle: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
    menuTwoTitle: "\u041C\u043E\u0438 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
    menuThreeTitle: "\u0421\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0438 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
    myProfile: "\u041C\u043E\u0439 \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
    or: "or"
  },
  "sk-sk": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "V\u0161eobecn\xE9",
    menuTwoTitle: "Moje rezerv\xE1cie",
    menuThreeTitle: "S\xFAhlas a komunik\xE1cia"
  }),
  "sv-se": {
    createAccount: "Skapa anv\xE4ndare",
    firstTimeHere: "F\xF6rsta g\xE5ngen du \xE4r h\xE4r?",
    logIn: "Logga in",
    logOut: "Logga ut",
    menuOneTitle: "Personuppgifter",
    menuTwoTitle: "Mina bokningar",
    menuThreeTitle: "Samtycke och integritet",
    myProfile: "Min profil",
    or: "or"
  },
  "tr-tr": __spreadProps(__spreadValues({}, englishContent), {
    menuOneTitle: "Genel",
    menuTwoTitle: "Rezervasyonlar\u0131m",
    menuThreeTitle: "Olur ve ileti\u015Fim",
    myProfile: "Profilim"
  })
};
const getLoginBadgeContent = (locale) => {
  var _a;
  const normalizedLocale = locale.toLowerCase().replace("_", "-");
  return (_a = contentByLocale[normalizedLocale]) != null ? _a : englishContent;
};
export {
  getLoginBadgeContent
};
